/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-05 09:53:30
 */
import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import './roleConfig.less';
import { createBEM, createNamespace } from 'src/util/bem';
import FrameContentBg from 'src/pages/layout/components/frameContentBg';
import RoleConfigApi from './api/roleConfigApi';
import { Toast } from 'src/util/toast';
import { CommonUtil } from 'src/util/commonUtil';
import Button from 'src/types/iview/Button';
import EnumAuthorityType from 'src/enums/enumAuthorityType';
import './menuReleation.less';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import { Integer } from 'src/types/base';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
let bem = createBEM('menu-releation');

@Component({ name: 'menu-releation' })
export default class RoleConfig extends Vue.Component<any> {
    authorityLevels: any = 1;
    data: any = [];
    sourceData: any = [];
    interfaceList: { id: number; type: number; power_name: string; power_url: string }[] = [];
    selectIds: number[] = [];
    loading: boolean = false;
    currentMenu: Integer = null;
    async mounted() {
        await this.queryAllPower();
    }
    async queryAllPower() {
        let menu = JSON.parse(JSON.stringify(this.$store.state.layout.menus));
        let { code, data } = await RoleConfigApi.queryAllPower();
        let allmenus: { id: number; type: number; power_name: string; power_url: string }[] = [];
        let allIndeterfase: { id: number; type: number; power_name: string; power_url: string }[] = [];
        this.interfaceList = allIndeterfase;
        data.data_info.forEach(i => {
            if (i.type === EnumAuthorityType.Menu.getId()) {
                allmenus.push(i);
            } else {
                allIndeterfase.push(i);
            }
        });
        if (code === 0) {
            CommonUtil.treeForEach(menu, (i: any) => {
                if (!i.children || i.children.length === 0) {
                    let realMenu = allmenus.find(sub => i.path === sub.power_url);
                    if (!realMenu) {
                        console.log(`菜单【${i.title}】没有录入`);
                        return;
                    }
                    i.id = realMenu.id;
                } else {
                    i.expand = true;
                }
            });
            this.sourceData =Object.freeze( [
                {
                    title: '系统菜单',
                    expand: true,
                    children: menu,
                },
            ]);
            this.data = Object.freeze(JSON.parse(JSON.stringify(this.sourceData)));
        }
    }
    async save() {
        if (!this.currentMenu) {
            return Toast.error('请选择菜单');
        }
        this.loading = true;
        let { code } = await RoleConfigApi.addMenuInterfaceRelateion({
            menu_id: this.currentMenu,
            power_ids: this.selectIds,
            authority_levels: this.authorityLevels,
        });
        if (code === 0) {
            Toast.success('保存成功');
        }
        this.loading = false;
    }
    async selectChange(data) {
        if (data[0] && !data[0].children) {
            this.currentMenu = data[0].id;
        }
        let res = await RoleConfigApi.queryMenuInterfaceRelateion(this.currentMenu as number);
        if (res.code === 0) {
            this.selectIds = res.data.map(i => i.power_id);
        }
    }
    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    <FrameSideBg padding={false} style="height: 100%">
                        <div class={createNamespace('pt30')} style="height:100%;overflow:auto;">
                         <tree ref="tree" class={bem()} data={this.data} check-directly on-on-select-change={this.selectChange.bind(this)} />
                        </div>
                    </FrameSideBg>
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div class={bem('right-menu-title')}>
                        功能权限设置
                        <Button type="primary" on-click={this.save.bind(this)}>
                            保存
                        </Button>
                        <CommonSelect dataSource={[{ name: '超管', id: 0 }, { name: '所有用户', id: 1 }]} v-model={this.authorityLevels} />
                    </div>
                    <FrameContentBg showCorner={false} radius={true}>
                        <div class={createNamespace('pa30')}>
                            <checkbox-group v-model={this.selectIds}>
                                {this.interfaceList.map(i => {
                                    return (
                                        <checkbox size="large" label={i.id}>
                                            <div>{i.power_name}</div>
                                            <div>{i.power_url}</div>
                                        </checkbox>
                                    );
                                })}
                            </checkbox-group>
                        </div>
                    </FrameContentBg>
                </i-content>
            </layout>
        );
    }
}
